export enum CancelReasonTravel {
  INSURED_VIA_EMPLOYER = '1',
  INSURED_VIA_UNION = '2',
  INSURED_VIA_PARTNER = '3',
  NOT_IN_NEED = '4',
}
